module.exports = __webpack_public_path__ + "static/media/botxo.7f74dddd.svg";